module.exports = __webpack_public_path__ + "../QAHF/appsettings.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=../QAHF/[name].[ext]!./configs/appSettings/QAHF/appsettings.js
// module id = 762
// module chunks = 1